import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import axios from "../../plugins/axios";

const useAccountAdvisers = (accountId, adviceTypeId) =>
    useQuery([queryKeys.accountAdvisers, accountId, adviceTypeId], async () => {
        let response = await axios.get(`${process.env.REACT_APP_CASENEST_API_URL}/getaccountadvisers/${accountId}?adviceTypeId=${adviceTypeId}`);
        return response.data;
    }, {
        enabled: !!accountId && !!adviceTypeId,
        staleTime: 600000,
        cacheTime: 900000
    });

export default useAccountAdvisers;
